export const masterFirebaseConfig = {
  apiKey: "AIzaSyAoyMPs1lHGoIpoQ0np5Z8cdpDy9B9mJJY",
  authDomain: "kinfolk-42023.firebaseapp.com",
  databaseURL: "https://kinfolk-42023.firebaseio.com",
  projectId: "kinfolk-42023",
  storageBucket: "kinfolk-42023.appspot.com",
  messagingSenderId: "6705874336"
};



// WEBPACK FOOTER //
// /Users/julia/Desktop/kinfolk/src/app/api-keys.ts